import React, { FC } from 'react';
import { HomeExpiredCalled } from './HomeExpiredCalled';
import { HomeExpiredContacted } from './HomeExpiredContacted';
import { HomeExpiredUncontacted } from './HomeExpiredUncontacted';
import { useUser } from '../../user/useUser';

type Props = {
  isContacted: boolean;
  hasCalled: boolean;
  onCall: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const HomeExpiredTarget: FC<Props> = ({
  hasCalled,
  isContacted,
  onCall,
}) => {
  const {
    currentUser: { phoneNumber },
  } = useUser();
  if (hasCalled) {
    return <HomeExpiredCalled phoneNumber={phoneNumber} />;
  }
  if (isContacted) {
    return <HomeExpiredContacted onClick={onCall} />;
  }
  return <HomeExpiredUncontacted onClick={onCall} />;
};
